<template>
    <div class="HdTicket">
        <div class="main">
            <div>
                <el-tabs v-model="activeName" @tab-click="activeNameClick">
                    <el-tab-pane :label="'我的票券('+allcount+')'" name="all"></el-tab-pane>
                    <el-tab-pane :label="'领取的票券('+getcount+')'" name="wait"></el-tab-pane>
                </el-tabs>
            </div>
            <template v-if="myTickLists && myTickLists.length == 0 && activeName == 'all' ">
                <div class="null">
                    <img src="../../../../common/images/search/search-null.png" alt="">
                    <p>当前暂无票券</p>
                </div>
            </template>
            <template v-else>
                <el-table :data="myTickLists" style="width: 100%">
                    <el-table-column label="活动名称" width="365px">
                        <template slot-scope="scope">
                            <div class="courses-card" @click="gotoRouterDetaills(scope.row.eventid)">
                                <div class="img"><img v-lazy="scope.row.coveratturlid" :alt="scope.row.title"></div>
                                <div class="msg">
                                    <p class="text-overflow">{{scope.row.title}}</p>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="票券名称" align="center" prop="ticketname"></el-table-column>
                    <el-table-column label="票券张数" align="center">
                        <template slot-scope="scope"><span>{{scope.row.ticketcount}}张</span></template>
                    </el-table-column>
                    <el-table-column label="操作" align="right" width="200">
                        <template slot-scope="scope">
                            <div class="position">
                                <template>
                                    <span class="active" @click='openTicketDet(scope.row)'>查看票券</span>
                                    <span class="padding">|</span>
                                    <span class="active" @click='openShare(scope.row.eventid,scope.row.shareurl)'>分享票券</span>
                                </template>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination v-if="this.activeName=='all'" background layout="prev, pager, next" :current-page.sync='myTickPost.page'  @current-change="handleCurrentChange2" :total="rowCount"> </el-pagination>
                <el-pagination v-if="this.activeName=='wait'" background layout="prev, pager, next" :current-page.sync='myTickApi.page'  @current-change="handleCurrentChange" :total="rowCount"> </el-pagination>
            </template>
        </div>
        <el-dialog title="分享票券" :visible.sync="dialogQrcode" :before-close="handleQrcode" width="300px" class="sharePoup">
            <img class="qrcodeimg" :src="qrcodeimg" alt="二维码">
            <p>微信扫码分享票券给好友</p>
        </el-dialog>
        <TicketDet ref="ticketDet"></TicketDet>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import {urlToQRCode} from 'common/js/tools'
    import {getEventGettedTickets,getMyEventTickets} from 'api/personalCenterApi'
    import TicketDet from './../components/ticketDet'
    export default {
        name: 'HdTicket',
        data () {
            return {
                activeName: 'all', // 选项列表名称
                myTickLists: [], // 课程列表
                myTickApi: {resulttype: '', page: 1, pageSize: 10},  // 接口api
                myTickPost: {page: 1, pageSize: 10},  // 接口api
                rowCount: 0,  // 数据条数
                dialogQrcode: false,
                qrcodeimg: '',
                allcount:'', //我的票券
                getcount:'', //领取的票券
            }
        },
        mounted () {
            //我的票券列表
            this.getMyList(1)
            // 领取的票券列表
            // this.getTicketList(2, 1)
        },
        methods: {
            //获取我的票券列表
            getMyList(page){
                this.myTickPost.page = page
                this.setLoading(true)
                getMyEventTickets({
                    data: this.myTickPost,
                    success: data => {
                        this.setLoading(false);
                        this.myTickLists = data.data.content;
                        this.rowCount = data.data.pageinfo.rowCount;
                        this.allcount=data.data.allcount;
                        this.getcount=data.data.getcount
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            getTicketList(resulttype, page) {  // 票券列表
                this.myTickApi.resulttype = resulttype
                this.myTickApi.page = page
                this.setLoading(true)
                getEventGettedTickets({
                    data: this.myTickApi,
                    success: data => {
                        this.setLoading(false);
                        this.myTickLists = data.data.content;
                        this.rowCount = data.data.pageinfo.rowCount;
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            activeNameClick(activeName) { // 列表切换
                switch(activeName.name) {
                    case 'all':
                        this.getMyList(1);
                        // this.myTickApi.resulttype = 1
                        break;
                    case 'wait':
                        // this.myTickApi.resulttype = 2
                        this.getTicketList(2, 1);
                        break;
                }
                // 切换列表的同时 页数重置
                // this.getTicketList(this.myTickApi.resulttype, 1)
            },
            handleCurrentChange(val) { // 数据翻页
                this.getTicketList(this.myTickApi.resulttype, val)
            },
            handleCurrentChange2(val){
                this.getMyList(val)
            },
            gotoRouterDetaills(id) {  // 前往详情页面
                const { href } = this.$router.resolve({
                    name: "HdDetails",
                    query: {
                        eventid: id
                    }
                });
                window.open(href, '_blank');
            },
            //票券详情
            openTicketDet(row){
                if(this.activeName=='all'){
                    this.$refs.ticketDet.open(row.eventid,row.orderno)
                }else{ //领取的票券跳转详情
                    this.$refs.ticketDet.open(row.eventid,row.itemid,1)
                }
            },
            //分享票券
            openShare(eventid,shareurl){
                this.dialogQrcode = true;
                this.qrcodeimg=urlToQRCode(shareurl)
                // this.qrcodeimg = urlToQRCode(window.location.origin+'/m/MReportDetails?eventid='+eventid)  // 二维码内容
            },
            handleQrcode() {
                this.dialogQrcode = false
            },
            ...mapActions(['setLoading'])
        },
        filters: {},
        watch: {
            $route: {
                handler() {
                    // 路由是否发生变化
                    if (this.$route.query.kmctype) {
                        this.myTickApi.kmctype = this.$route.query.kmctype.toString()
                    }
                    // 订单列表接口
                    this.getTicketList(1, 1)
                    this.activeName = 'all'
                }
            }
        },
        computed: {},
        components:{
            TicketDet
        }
    }
</script>

<style lang="scss" type="text/scss" scope>
    .HdTicket {
        /*分享弹窗样式*/
        .sharePoup{
            .el-dialog__header{
                border-bottom: 1px solid #e5e5e5;
                .el-dialog__title{
                    font-size: 14px;
                }
            }
            .qrcodeimg{
                margin:0 auto;
            }
            p{
                text-align: center;
                color: #409EFF;
            }
        }
        .el-dialog__body {
            padding-top: 12px;
        }
        .main {
            position: relative;
        }
        .el-select {
            position: absolute;
            width: 128px;
            right: 30px;
            top: 8px;
        }
        .el-table {
            thead {
                th {
                    background: #E5E5E5;
                }
            }
            tr {
                td {
                    padding-top: 15px;
                }
            }
            .color-1 {
                color: #0ABF53;
            }
            .color-2 {
                color: #FFA904;
            }
            .color- {
                color: #999999;
            }
            .text-overflow {
                -webkit-line-clamp: 3;
            }
        }
    }
</style>